export default {
  POST_FORGOT_PASSWORD_REQUEST: "POST_FORGOT_PASSWORD_REQUEST",
  POST_FORGOT_PASSWORD_RESPONSE: "POST_FORGOT_PASSWORD_RESPONSE",
  POST_FORGOT_PASSWORD_RESPONSE_CLEAR: "POST_FORGOT_PASSWORD_RESPONSE_CLEAR",

  POST_RESET_PASSWORD_REQUEST: "POST_RESET_PASSWORD_REQUEST",
  POST_RESET_PASSWORD_RESPONSE: "POST_RESET_PASSWORD_RESPONSE",
  POST_RESET_PASSWORD_RESPONSE_CLEAR: "POST_RESET_PASSWORD_RESPONSE_CLEAR",
};
